import type { DirectiveBinding } from "vue";
import Logger from "~/utils/logger";

// 存储元素的原始点击处理器
const originalHandlers = new WeakMap<HTMLElement, ((event: MouseEvent) => void) | null>();

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding<string>) {
    // 保存原有的点击事件处理器
    const originalOnClick = el.onclick;
    originalHandlers.set(el, originalOnClick);

    // 创建新的点击处理器
    const newClickHandler = (event: MouseEvent) => {
      // 先执行原有的点击事件
      if (originalOnClick) {
        originalOnClick.call(el, event);
      }

      // 然后执行日志记录
      if (binding.value) {
        try {
          Logger.event(binding.value);
        } catch (error) {
          console.warn("Logger directive error:", error);
        }
      }
    };

    // 设置新的点击处理器
    el.onclick = newClickHandler;
  },

  unmounted(el: HTMLElement) {
    // 恢复原始的点击处理器
    const originalHandler = originalHandlers.get(el);
    if (originalHandler !== undefined) {
      el.onclick = originalHandler;
      originalHandlers.delete(el);
    } else {
      el.onclick = null;
    }
  },
};
